import React from 'react';

import styles from './App.module.css';
import Graph from './components/Graph';
import Header from './components/Header';

function App() {
  return (
    <div className={styles.app}>
      <div className={styles.container}>
        <Header />
        <main>
          <h1 className={styles.title}>Spending - Last 7 days</h1>
          <Graph />
          <div className={styles.divider} />
          <div className={styles.summary}>
            <div className={styles.total}>
              <p className={styles.label}>Total this month</p>
              <p className={styles.value}>$478.33</p>
            </div>
            <div className={styles.variation}>
              <p className={styles.value}>+2.4%</p>
              <p className={styles.label}>from last month</p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default App;
